import permissions from './permission-list'

export default [
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/views/faq/index.vue'),
    meta: {
      pageTitle: 'FAQ',
      resource: permissions.faq,
      action: 'read',
      navActiveLink: 'faq',
      breadcrumb: [
        {
          text: 'Daftar FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/faq/create',
    name: 'faq-create',
    component: () => import('@/views/faq/create.vue'),
    meta: {
      pageTitle: 'Buat Kategori FAQ',
      resource: permissions.faq,
      action: 'manage',
      navActiveLink: 'faq',
      breadcrumb: [
        {
          text: 'Daftar FAQ',
          active: false,
          to: { path: '/faq' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/faq/:id/edit',
    name: 'faq-edit',
    component: () => import('@/views/faq/edit.vue'),
    meta: {
      pageTitle: 'Edit FAQ',
      resource: permissions.faq,
      action: 'manage',
      navActiveLink: 'faq',
      breadcrumb: [
        {
          text: 'FAQ',
          active: false,
          to: { path: '/faq' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
